import Input from './Input';

export default Input;
export type { IInputProps } from './Input';
